// ─── Formatting Utilities ────────────────────────────────

/**
 * Returns a human-readable relative time string (e.g. "just now", "5 min ago", "3d ago").
 * Falls back to "Month Day" format for dates older than 7 days.
 */
export function timeAgo(date: Date | null): string {
    if (!date) return "";
    const seconds = Math.floor((Date.now() - new Date(date).getTime()) / 1000);
    if (seconds < 60) return "just now";
    if (seconds < 3600) return `${Math.floor(seconds / 60)} min ago`;
    if (seconds < 86400) return `${Math.floor(seconds / 3600)}h ago`;
    if (seconds < 604800) return `${Math.floor(seconds / 86400)}d ago`;
    return new Date(date).toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
    });
}
